module.exports = __webpack_public_path__ + "img/other-workplace.f8f5e3aa.png";